import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEN from 'element-ui/lib/locale/lang/en' // 引入饿了么的英文包
import elementZH from 'element-ui/lib/locale/lang/zh-CN' // 引入饿了么的中文包

Vue.use(VueI18n)

// 语言包
const messages = {
  zh: {
    // 通用
    location: '当前位置',
    // tiktok授权
    delete: '删除',
    yes: '是',
    no: '否',
    authorize: '授权',
    shopName: '店铺名称',
    authStatus: '启用状态',
    shopStatus: '授权状态',
    addTime: '添加时间',
    startTime: '开始时间',
    endTime: '结束时间',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '搜索',
    reset: '重置',
    addShop: '新增店铺',
    setInstruction: '仓库设置说明',
    siteName: '站点名称',
    linkedAccount: '关联账号',
    isSync: '自动同步订单',
    operation: '操作',
    edit: '编辑',
    reauthorize: '重新授权',
    enable: '启用',
    expired: '已过期',
    shopPlatform: '店铺平台',
    footerInstructions: '点击“授权”后，将为你打开TikTok页面，请先登录TikTok账号',
    cancel: '取消',
    save: '保存',
    delInstructions: '删除店铺后，信息将彻底删除，且不可恢复？',
    prompt: '提示',
    confirm: '确定',
    success: '成功',
    fail: '失败',
    editShop: '编辑店铺',
    // 首页
    orderTracking: '订单跟踪',
    orderNum: '订单数',
    orderQuantity: '订单件数',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本周',
    thisMonth: '本月',
    unpaid: '未付款',
    paid: '已付款',
    scheduling: '排单中',
    producing: '生产中',
    shipped: '已发货',
    statisticalData: '数据统计',
    todayRevenue: '今日营业额（元）',
    thisWeekRevenue: '本周营业额（元）',
    todayPay: '今日付款（元）',
    rechargeAmount: '当月充值（元）',
    designNum: '设计次数',
    yestSaleActPay: '昨日营业额（元）',
    monthSaleActPay: '本月营业额（元）',
    yestProActPay: '昨天付款（元）',
    balance: '当前余额（元）',
    imgNum: '总图片量',
    revenueReport: '收入统计',
    todayTransactions: '今日交易',
    yesterdayTransactions: '昨日交易',
    transAct: '成交金额（元）',
    refAct: '退款金额（元）',
    refNum: '退款笔数（笔）',
    systemNotices: '系统公告',
    pinned: '置顶',
    transAct2: '成交金额',
    transNum: '成交笔数',
    refAct2: '退款金额',
    // 侧边栏sideBar
    authorizeShopee: 'Shopee授权',
    authorizeLazada: 'Lazada授权',
    authorizeTiktok: 'Tiktok授权',
    listOnShopee: 'Shopee发布',
    listOnLazada: 'Lazada发布',
    listOnTikTok: 'TikTok发布',
    topUp: '账户充值',
    myDesign: '我的设计',
    RealName: '实名认证',
    myGallery: '我的图库',
    lastLogin: '最近登录',
    loginTime: '登录时间',
    loginIp: '登录IP',
    loginLocation: '登录地点',
    frequentActions: '常用操作',
    complaintEmail: '投诉邮箱',
    FAQ: '常见问题',
    seeMore: '查看更多',
    more: '更多',
    // 推荐
    popularPicks: '热卖推荐',
    latestPicks: '新品速递',
    avgDelivery: '平均发货时效',
    // 订单
    TiktokOrder: 'Tiktok订单',
    // businessOrders: '业务订单',
    // allOrders: '全部订单',
    // unassigned: '未安排',
    // awaitingShipOrder: '待打单',
    // awaitingPickOrder: '待揽收',
    // shipOrder: '已交运',
    // cancelOrder: '已取消',
    // afterSale: '售后订单',
    // refundOrder: '退货到库',
      sort:'排序',
      orderTime :'下单时间',
      orderTime2 :'订单下单时间',
      warningTime:'接收预警时间',
      actualShipTime:'实际发货时间',
      updatedTime:'更新时间',
      orderSource: '订单来源',
      orderSourcePlaceholder: '请选择订单来源',
      amazonSite: '来源国家',
      amazonSitePlaceholder: '请选择来源国家',
      matchType: '匹配类型',
      matchTypePlaceholder: '请选择匹配类型',
      createTime: '创建时间',
      payTime: '支付时间',
      sendTime: '发货时间',
      appNos: '订单编号',
      designId: '成品编号',
      itemSku: '产品SKU',
      orderRemarkType: '标记类型',
      orderRemarkTypePlaceholder: '请选择标记类型',
      orderRemarkColor: '标记颜色',
      orderRemarkColorPlaceholder: '请选择标记颜色',
      title: '标题',
      nickName: '操作账号',
      orderStatus: '订单状态',
      amazonOrderStatus: '第三方状态',
      manufacturer: '工厂编号',
      batch: '批量',
      expand: '展开',
      collapse: '收起',
      batchQuery: '多单号查询请用英文逗号隔开',
      batchPay: '批量支付货款',
      batchLabel: '批量获取面单',
      batchCreateOrders: '批量制单',
      batchSetShipping: '批量设置物流',
      batchTag: '批量标记',
      syncOrder: '同步订单',
      batchDownloadCombine: '下载合并面单',
      exportOrders: '导出订单',
      importOrders: '导入订单',
      profitSet: '利润设置',
      refundApply: '退货到库申请',
      productInfo: '产品信息',
      salesTotal: '销售总计',
      paymentTotal: '货款总计',
      recipientShipping: '收件人/物流',
      thirdPartyStatus: '第三方状态/时间',
      statusTime: '状态/时间',
      operator: '操作人',
      viewOriginalImage: '查看原图',
      productAmount: '产品金额',
      shippingFee: '运费',
      salesPromotion: '销售促销 ',
      sellingTotal: '售卖总计',
      productCount: '产品数',
      quantity: '件数',
      productPayment: '产品货款',
      discountAmount: '优惠金额',
      totalCost: '成本总计',
      profit: '利润',
      profitMargin: '利润率',
      cancelOrder: '取消订单',
      uploadShippingLabel: '上传面单',
      updateShippingLabel: '修改面单',
      promisedShipTime: '承诺发货时间',
      orderCancelTime: '订单取消时间',
      create: '创建',
      paid2: '支付',
      reviewed: '审核',
      shipped2: '发货',
      relatedProducts: '关联产品',
      appNo: '订单号',
      num: '数量',
      normalShipping: '正常发货',
      overdue: '超期',
      hoursShipping: '小时发货',
      hoursToExpire: '小时后过期',
      willExpireIn: '将在',
      hours: '小时',
      exportAll: '导出全部',
      exportPage: '导出单页',
      // tiktok线上产品
      onSale: '在售',
      underReview: '审核中',
      draft: '草稿箱',
      failed: '失败',
      takenDown: '下架',
      frozen: '冻结',
      suspectedDeleted: '疑似删除',
      publishing: '发布中',
      proName: '产品名称',
      addProduct: '新增产品',
      syncProducts: '同步产品',
      bulkEdit: '批量编辑',
      bulkTakeDown: '批量下架',
      storeMigration: '整店搬家',
      productMigration: '产品搬家',
      product: '产品',
      store: '所属店铺',
      color: '颜色',
      size: '尺码',
      price: '价格',
      stock: '库存',
      time: '时间',
      productCode: '产品编号',
      syncStatus: '同步状态',
      publishNow: '立即发布',
      schedulePublish: '定时发布',
      cancelSchedule: '取消定时',
      bulkDelete: '批量删除',
      launch: '上架',
      selected: '已选中',
      items: '条数据',
      advisory: '问题没解决？提交工单',




  },
  en: {
    // 通用
    location: 'Location',
    // tiktok授权
    shopName: 'Shop Name',
    authStatus: 'Enabled Status',
    shopStatus: 'Authorization Status',
    addTime: 'Add Time',
    startTime: 'start',
    endTime: 'end',
    startDate: 'start',
    endDate: 'end',
    search: 'Search',
    reset: 'Reset',
    addShop: 'Add Shop',
    setInstruction: 'Warehouse Setup Instructions',
    siteName: 'Site Name',
    linkedAccount: 'Linked Account',
    isSync: 'Automatically Synchronize Orders',
    operation: 'operation',
    edit: 'Edit',
    authorize: 'Authorize',
    reauthorize: 'Reauthorize',
    enable: 'Enable',
    delete: 'Delete',
    yes: 'Yes',
    no: 'No',
    expired: 'Expired',
    shopPlatform: 'Platform',
    footerInstructions: 'After clicking "Authorize", we will open TikTok for you. Please log in to your TikTok account first.',
    cancel: 'Cancel',
    save: 'Save',
    delInstructions: 'After deleting the store, the information will be permanently deleted and cannot be recovered?',
    prompt: 'prompt',
    confirm: 'Confirm',
    success: 'Success',
    fail: 'Fail',
    editShop: 'Edit Shop',
    // 首页
    orderTracking: 'Order Tracking',
    orderNum: 'Order Count',
    orderQuantity: 'Total Quantity',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    unpaid: 'Unpaid',
    paid: 'Paid',
    scheduling: 'Scheduling',
    producing: 'Producing',
    shipped: 'Shipped',
    statisticalData: 'Statistical Data',
    todayRevenue: "Today's Revenue (CNY)",
    thisWeekRevenue: "This Week's Revenue (CNY)",
    todayPay: "Today's Payments (CNY)",
    rechargeAmount: "Monthly Top-up (CNY)",
    designNum: 'Design Count',
    yestSaleActPay: "Yesterday's Revenue (CNY)",
    monthSaleActPay: 'Monthly Revenue (CNY)',
    yestProActPay: "Yesterday's Payment (CNY)",
    balance: 'Current Balance (CNY)',
    imgNum: 'Total Images',
    revenueReport: 'Revenue Report',
    todayTransactions: "Today's Transactions",
    yesterdayTransactions: "Testerday's Transactions",
    transAct: 'Transaction Amount (CNY)',
    refAct: 'Refund Amount (CNY)',
    refNum: 'Refund Count',
    systemNotices: 'System Notices',
    pinned: 'Pinned',
    transAct2: 'Transaction Amount',
    transNum: 'Transaction Count',
    refAct2: 'Refund Amount',
    // 侧边栏sideBar
    authorizeShopee: 'Authorize Shopee',
    authorizeLazada: 'Authorize Lazada',
    authorizeTiktok: 'Authorize Tiktok',
    listOnShopee: 'List on Shopee',
    listOnLazada: 'List on Lazada',
    listOnTikTok: 'List on TikTok',
    topUp: 'Top Up',
    myDesign: 'My Design',
    RealName: 'Real-name Verification',
    myGallery: 'My Gallery',
    lastLogin: 'Last Login',
    loginTime: 'Login Time',
    loginIp: 'Login IP',
    loginLocation: 'Login Location',
    frequentActions: 'Frequent Actions',
    complaintEmail: 'Complaint Email',
    FAQ: 'FAQ',
    seeMore: 'See More',
    more: 'More',
    // 推荐
    popularPicks: 'Popular Picks',
    latestPicks: 'Latest Picks',
    avgDelivery: 'Average Shipping Time',
    // 订单
    TiktokOrder: 'Tiktok Orders',
    // businessOrders: 'Business Orders',
    // allOrders: 'All Orders',
    // unassigned: 'Unassigned',
    // awaitingShipOrder: 'Pending Print',
    // awaitingPickOrder: 'Awaiting Pickup',
    // shipOrder: 'Shipped',
    // cancelOrder: 'Canceled',
    // afterSale: 'After-sale Orders',
    // refundOrder: 'Return Received',
    sort:'Sort',
    orderTime :'Order Time',
    orderTime2 :'Order Time',
    warningTime:'Warning Time',
    actualShipTime:'Actual Ship Time',
    updatedTime:'Updated Time',
    orderSource: 'Order Source',
    orderSourcePlaceholder: 'Please Select Order Source',
    amazonSite: 'Country of Origin',
    amazonSitePlaceholder: 'Please Select Country of Origin',
    matchType: 'Match Type',
    matchTypePlaceholder: 'Please Select Match Type',
    createTime: 'Created Time',
    payTime: 'Payment Time',
    sendTime: 'Ship Time',
    appNos: 'Order ID',
    designId: 'Product ID',
    itemSku: 'Product SKU',
    orderRemarkType: 'Tag Type',
    orderRemarkTypePlaceholder: 'Please Select Tag Type',
    orderRemarkColor: 'Tag Color',
    orderRemarkColorPlaceholder: 'Please Select Tag Color',
    title: 'Title',
    nickName: 'Operator Account',
    orderStatus: 'Order Status',
    amazonOrderStatus: 'Third-party Status',
    manufacturer: 'Factory ID',
    batch: 'Batch',
    expand: 'Expand',
    collapse: 'Collapse',
    batchQuery: 'Search multiple numbers: Separate with commas.',
    batchPay: 'Batch Pay',
    batchLabel: 'Batch Print Labels',
    batchCreateOrders: 'Batch Create Orders',
    batchSetShipping: 'Batch Set Shipping',
    batchTag: 'Batch Tag',
    syncOrder: 'Sync Orders',
    batchDownloadCombine: 'Download Combined Labels',
    exportOrders: 'Export Orders',
    importOrders: 'Import Orders',
    profitSet: 'Profit Settings',
    refundApply: 'Return to Warehouse Request',
    productInfo: 'Product Information',         
    salesTotal: 'Sales Total',                    
    paymentTotal: 'Payment Total',               
    recipientShipping: 'Recipient/Shipping',      
    thirdPartyStatus: '3rd-party Status/Time',    
    statusTime: 'Status/Time',            
    operator: 'Operator',
    viewOriginalImage: 'View Original Image',
    productAmount: 'Product Amount',
    shippingFee: 'Shipping Fee',   
    salesPromotion: 'Sales Promotion',  
    sellingTotal: 'Selling Total',  
    productCount: 'Product Count',    
    quantity: 'Quantity',   
    productPayment: 'Product Payment',
    discountAmount: 'Discount Amount',
    totalCost: 'Total Cost',
    profit: 'Profit',
    profitMargin: 'Profit Margin',
    cancelOrder: 'Cancel Order',
    uploadShippingLabel: 'Upload Label',
    updateShippingLabel: 'Update Label',
    promisedShipTime: 'Promised Ship Time',
    orderCancelTime: 'Order Cancel Time',
    create: 'Created',
    paid2: 'Paid',
    reviewed: 'Reviewed',
    shipped2: 'Shipped',
    relatedProducts: 'Related Products',
    appNo: 'Order ID',
    num: 'Quantity',
    normalShipping: 'Normal Shipping',       
    overdue: 'Overdue',                       
    hoursShipping: 'Hour Shipping',          
    hoursToExpire: 'Hours to Expire',    
    willExpireIn: 'Will Expire In',
    hours: 'hours',
    exportAll: 'Export All',
    exportPage: 'Export Current Page',
    onSale: 'On Sale',
    underReview: 'Under Review',
    draft: 'Draft',
    failed: 'Failed',
    takenDown: 'Taken Down', 
    frozen: 'Frozen',
    suspectedDeleted: 'Suspected Deleted',
    publishing: 'Publishing',
    proName: 'Product Name',
    addProduct: 'Add Product',            
    syncProducts: 'Sync Products',         
    bulkEdit: 'Bulk Edit',                  
    bulkTakeDown: 'Bulk Take Down',        
    storeMigration: 'Store Migration',      
    productMigration: 'Product Migration',
    store: 'Store',           
    color: 'Color',        
    size: 'Size',          
    price: 'Price',      
    stock: 'Stock',      
    time: 'Time',      
    productCode: 'Product Code',       
    syncStatus: 'Sync Status',
    publishNow: 'Publish Now',             
    schedulePublish: 'Schedule Publish',   
    cancelSchedule: 'Cancel Schedule',      
    bulkDelete: 'Bulk Delete',                       
    launch: 'Launch',   
    selected: 'Selected',
    items: 'items',                    
    advisory: 'Still need help? Contact support.',                    

  }
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('preferred-language') || 'zh', // 默认中文
  messages: {
    zh: {
      ...elementZH,
      ...messages.zh
    },
    en: {
      ...elementEN,
      ...messages.en
    }
  },
  silentTranslationWarn: true // 禁止翻译警告
})

// 配置 Element UI 国际化
import Lang from 'element-ui/lib/locale'
Lang.i18n((key, value) => i18n.t(key, value))

export default i18n
